export const es = {
    seo: {
        title: 'MyCarCosts | Ultimate Car Expense Tracker & Repair Analysis',
        description: 'Track car maintenance, expenses, and history. Use our AI-powered repair vs sell analyzer to make data-driven decisions about your vehicle.'
    },
    common: {
        back: "Atrás",
        save: "Guardar",
        saved: "Guardado",
        cancel: "Cancelar",
        close: "Cerrar",
        accessDenied: "Acceso Denegado",
        noExportPermission: "No tienes permiso para exportar los datos de este coche.",
        delete: "Eliminar",
        downgrade: "Degradar",
        downgradeConfirm: "¿Estás seguro de que quieres degradar a un plan gratuito?",
        edit: "Editar",
        loading: "Cargando...",
        confirm: "Confirmar",
        processing: "Procesando...",
        history: "Historial",
        currentCar: "Coche Actual",
        purchasedCarTitle: "Compra de Coche",
        initialCost: "Costo Inicial",
        done: "Hecho",
        ok: "Aceptar",
        error: "Error",
        errorSaving: "Error al guardar los datos",
        mandatoryFieldsError: "Por favor, complete todos los campos obligatorios correctamente.",
        search: "Buscar",
        milesShort: "mi",
        kmShort: "km",
        invalidEmail: "Formato de correo electrónico no válido",
        today: "Hoy",
        car: "Coche",
        all: "Todo",
        deleteConfirm: "Eliminar",
        unsavedChangesTitle: "Cambios No Guardados",
        unsavedChangesMessage: "¿Quieres guardar los cambios antes de salir?",
        dontSave: "No Guardar",
        additionalOptions: "Opciones adicionales",
        add: "Agregar",
        fileTooLarge: "El archivo es demasiado grande. El tamaño máximo es {limit} MB.",
        storageFull: "Límite de almacenamiento excedido. El almacenamiento máximo es {limit} MB.",
        dailyUploadLimit: "Límite diario de carga alcanzado ({limit} archivos/día). Intenta de nuevo mañana.",
        hourlyUploadLimit: "Límite horario de carga alcanzado ({limit} archivos/hora). Intenta de nuevo en una hora.",
        fileCountLimit: "Máximo {limit} archivos permitidos por elemento.",
        emailParseLimitReached: "Límite de análisis de correo electrónico alcanzado. Por favor, actualiza tu plan o procesa manualmente.",
        emailLimitText: "Límite de procesamiento de correo electrónico alcanzado.",
        monthlyEmailScans: "Escaneos de Correo Electrónico Mensuales",
        lifetimeEmailScans: "Escaneos de Correo Electrónico de por Vida",
        monthlyFileScans: "Escaneos de Recibos Mensuales",
        lifetimeFileScans: "Escaneos de Recibos de por Vida",
        fileLimitText: "Límite de escaneo de recibos alcanzado.",
        planFreeTier: "Nivel gratuito",
        planProTier: "Nivel Pro",
        uploadFailed: "La carga falló",
        attachments: "Adjuntos",
        limitsAndUsage: "Límites y Uso",
        addresses: "direcciones",
        emailCopied: "¡Dirección de correo electrónico copiada!",
        units: {
            liters: "l",
            gallons: "gal",
            kilometers: "km",
            miles: "mi",
        },
        included: "Incluido",
        proOnly: "Solo PRO",
        month: "mes",
        openInNewTab: "Abrir en nueva pestaña",
        menu: "Menú",
        home: "Inicio",
        monthsShort: {
            0: "Ene",
            1: "Feb",
            2: "Mar",
            3: "Abr",
            4: "May",
            5: "Jun",
            6: "Jul",
            7: "Ago",
            8: "Sep",
            9: "Oct",
            10: "Nov",
            11: "Dic",
        },
    },
    carMetadata: {
        bodyType: "Tipo de Carrocería",
        drivetrain: "Tren Motriz",
        transmission: "Transmisión",
        bodyTypes: {
            sedan: "Sedán",
            hatchback: "Hatchback",
            wagon: "Familiar",
            suv: "SUV",
            crossover: "Crossover",
            coupe: "Coupé",
            convertible: "Convertible",
            pickup: "Pickup",
            van: "Furgoneta / Monovolumen",
            commercial: "Comercial",
            other: "Otro",
            not_specified: "-",
        },
        drivetrains: {
            not_specified: "-",
            fwd: "FWD",
            rwd: "RWD",
            awd: "AWD / 4x4",
            other: "Otro",
        },
        transmissions: {
            not_specified: "-",
            manual: "Manual",
            automatic: "Automático",
            cvt: "CVT",
            other: "Otro",
        },
        otherLabel: "Otro (especificar)",
        mileageLabel: "Kilometraje",
    },
    auth: {
        welcome: "Bienvenido",
        welcomeBack: "Bienvenido de nuevo",
        signIn: "Iniciar Sesión",
        signInWithGoogle: "Iniciar sesión con Google",
        signOut: "Cerrar Sesión",
        magicLinkDesc: "Recibe un enlace mágico en tu correo electrónico",
        magicLinkSent: "¡Enlace mágico enviado!",
        magicLinkCheckEmail: "Revisa tu correo electrónico y haz clic en el enlace para iniciar sesión.",
        emailAddress: "Dirección de Correo Electrónico",
        getMagicLink: "Obtener Enlace Mágico",
        sending: "Enviando...",
        linkSent: "Enlace Enviado",
        orContinueWith: "O continúa con",
        googleAccount: "Cuenta de Google",
        newUserNote: "¿Nuevo aquí? Tu cuenta se creará automáticamente tras tu primer inicio de sesión exitoso.",
        magicLinkError: "Error al enviar el enlace mágico. Por favor, verifica tu correo electrónico e inténtalo de nuevo.",
        genericError: "Ocurrió un error. Por favor, inténtalo de nuevo.",
        projectDescription: "Rastrea los costos de tu coche, mantenimiento e historial en un solo lugar.",
        loginError: "No se pudo iniciar sesión",
        loggingIn: "Iniciando sesión...",
        authenticating: "Autenticando...",
        authenticatingDesc: "Por favor, espera mientras aseguramos tu sesión.",
    },
    settings: {
        title: "Configuraciones",
        systemPreferences: "Preferencias del Sistema",
        appSettings: "Configuraciones de la Aplicación",
        dangerZone: "Zona de Peligro",
        theme: "Tema",
        language: "Idioma de la Interfaz",
        currency: "Moneda",
        units: "Unidades",
        distanceUnit: "Unidad de Distancia",
        volumeUnit: "Unidad de Volumen",
        expenseTypes: "Tipos de Gastos",
        expenseTypesDesc: "Gestionar categorías",
        categories: "Categorías",
        exportData: "Exportar Datos",
        exportDesc: "Descargar CSV completo",
        importData: "Importar Datos",
        importDesc: "Restaurar desde copia de seguridad CSV",
        deleteAccount: "Eliminar Cuenta",
        deleteAccountDesc: "Eliminar todos los datos permanentemente",
        enableSync: "Habilitar Sincronización",
        enableSyncDesc: "Sincronizar datos entre dispositivos",
        account: "Cuenta",
        accountPlan: "Plan de Cuenta",
        carsUsage: "Autos",
        carsLimitReached: "Límite de autos alcanzado",
        storageSize: "Tamaño de Almacenamiento",
        emailScans: "Escaneos por Correo",
        fileScans: "Escaneos de Recibos",
        plans: "Planes",
        currentlyPlan: "Actualmente",
        upgradePlan: "Actualizar",
        manageSubscription: "Gestionar suscripción",
        nextPayment: "Próximo pago",
        endsOn: "Termina el",
        adminConsole: "Consola de Administrador",
        systemControl: "Control del Sistema",
        customCategories: "Categorías y Etiquetas Personalizadas",
        interfaceTheme: "Tema de Interfaz",
        light: "Claro",
        dark: "Oscuro",
        timezone: "Zona horaria",
        timezoneDesc: "Utilizado para recordatorios de correo electrónico programados",
        timeFormat: "Formato de hora",
        timeFormat24h: "24 horas (14:30)",
        timeFormat12h: "12 horas (2:30 PM)",
        kilometers: "kilómetros (km)",
        miles: "millas (mi)",
        liters: "litros (l)",
        gallons: "galones (gal)",
        accountManagement: "Gestión de Cuenta",
        contactUs: "Contáctanos",
        contactDesc: "Para sugerencias, solicitudes de funciones y preguntas",
        logOut: "Cerrar Sesión",
        logOutConfirmTitle: "Cerrar Sesión",
        logOutConfirmMessage: "¿Estás seguro de que deseas cerrar sesión en tu cuenta?",
        keepAccount: "Mantener Cuenta",
        deleteAccountConfirmTitle: "Eliminar Cuenta",
        deleteAccountConfirmMessage: "¿Estás seguro de que deseas eliminar permanentemente tu cuenta y todos los datos de autos asociados? Esta acción no se puede deshacer.",
        deletePermanently: "Eliminar Permanentemente",
        deleting: "Eliminando...",
        contactSupport: "Contactar Soporte",
        messageSent: "¡Mensaje Enviado!",
        feedbackThanks: "Gracias por tus comentarios. Agradecemos tu opinión y lo revisaremos.",
        backToSettings: "Volver a Configuraciones",
        subjectLabel: "Asunto",
        messageLabel: "Mensaje",
        subjectPlaceholder: "¿De qué se trata esto?",
        messagePlaceholder: "Cuéntanos sobre tu sugerencia, solicitud de función o pregunta...",
        enterSubjectAlert: "Por favor ingresa un asunto",
        enterMessageAlert: "Por favor ingresa un mensaje",
        sendFailedAlert: "Error al enviar el mensaje. Por favor intenta de nuevo más tarde.",
    },
    export: {
        title: "Exportar Datos",
        generatePDF: "Generar PDF",
        carInformation: "Información del Auto",
        editInfo: "Edita la información a continuación para personalizar tu exportación",
        editInfoHint: "Puedes eliminar o modificar cualquier campo que no desees incluir",
        filters: "Filtros",
        expenseTypes: "Tipos de Gastos",
        includeNotes: "Incluir Notas",
        includeImages: "Incluir Archivos",
        hideDisabled: "Ocultar Elementos Deshabilitados",
        itemsCount: "{total} elementos, {selected} seleccionados",
        selectAll: "Seleccionar Todo",
        deselectAll: "Deseleccionar Todo",
        expenses: "Gastos",
        notes: "Notas",
        spareParts: "Piezas de Repuesto",
        images: "Imágenes",
        files: "Archivos",
        summary: "Resumen",
        totalExpenses: "Gastos Totales",
        totalItems: "Total de Elementos",
        generatedOn: "Generado el",
        noItemsSelected: "No se seleccionaron elementos para exportar",
        noItemsAvailable: "No hay elementos disponibles para exportar",
        generating: "Generando PDF...",
        downloadPDF: "Descargar PDF",
        pdfFileName: "{carName}_export_{date}.pdf",
        reportTitle: "Informe de Gastos del Vehículo",
        exportButton: "Exportar",
        generateCSV: "Generar CSV",
        formatSelectorTitle: "Elegir formato",
        formatSelectorMsg: "Por favor elige el formato de exportación",
        proFeatureExportTitle: "Función Pro: Exportar datos",
        proFeatureExportDesc: "Actualiza a PRO para exportar el historial de tu coche a PDF.",
        exportRestrictedPopup: "La exportación de datos solo está disponible para usuarios Pro.",
        allTypes: "Todos los Tipos",
        statistics: "Estadísticas",
        driven: "Conducido",
        since: "Desde",
        averageCost: "Costo Promedio",
        perKm: "por km",
        perMile: "por milla",
        period: "Período",
        dateFrom: "Desde",
        dateTo: "Hasta",
        allTime: "Limpiar filtro",
        periodHint: "Si no se selecciona ningún período, se muestran todos los gastos",
        noExpenses: "No hay gastos que coincidan con los filtros",
        expensesSection: "Gastos",
        attachmentsSection: "Adjuntos",
        imagesCount: "{count} imágenes",
        pdfsCount: "{count} PDFs",
        includeParts: "Incluir piezas de repuesto",
        pageLabel: "Página",
    },
    expenses: {
        title: "Gastos",
        newExpense: "Nuevo Gasto",
        editExpense: "Editar Gasto",
        openExpense: "Abrir entrada de gasto",
        details: "Detalles del Gasto",
        selectType: "Seleccionar Tipo",
        selectTypePlaceholder: "Seleccionar tipo de gasto...",
        shortDescriptionPlaceholder: "Descripción corta...",
        expenseTitle: "Título",
        logEntryTitleLabel: "Título del Registro (Opcional)",
        defaultTitlePlaceholder: "Título por defecto - {type}",
        autoTitlePlaceholder: "Se completará automáticamente según los tipos seleccionados",
        carDataTitle: "Datos del Coche",
        defaultTitlePrefix: "El título por defecto será -",
        addAnother: "Agregar otro tipo de gasto",
        addAnotherHint: "Si este registro incluye múltiples tipos de gastos, puedes agregarlos todos aquí para asegurar estadísticas precisas.",
        carValueDescription: "Valor de mercado estimado del coche en este momento.",
        type: "Tipo",
        date: "Fecha",
        amount: "Monto",
        totalAmount: "Total",
        splitCosts: "¿Dividir costos?",
        combineCosts: "Combinar costos",
        amountWork: "Trabajo",
        amountParts: "Piezas",
        mileage: "Kilometraje",
        carValue: "Valor del Coche",
        description: "Descripción",
        detailedDescription: "Descripción detallada",
        electricity: "Electricidad",
        fuelType: "Tipo de Combustible",
        fuelTypeOptions: {
            petrol: "Gasolina",
            diesel: "Diésel",
            lpg: "LPG",
            electricity: "Electricidad",
        },
        carData: "Datos del Coche",
        images: "Archivos",
        addImages: "Agregar Archivos",
        addImagesPDFs: "Agregar Imágenes o PDFs",
        deleteExpense: "Eliminar Gasto",
        deleteConfirm: "¿Estás seguro de que deseas eliminar este gasto?",
        saveSuccess: "Gasto guardado con éxito",
        thisExpense: "Este gasto",
        stats: {
            annual: "Anual",
            allTime: "Todo el Tiempo",
            avgMonth: "Promedio/Mes",
            costPer: "Costo/",
            noExpenses: "No hay gastos aún",
            dragToReorder: "Arrastra para reordenar",
        },
        expensesFound: "Creado",
        noExpensesFound: "No se encontraron gastos.",
        noDescription: "Sin descripción",
        imagesCount: "Imágenes ({count})",
        deleteImageTitle: "Eliminar Imagen",
        deleteImageConfirm: "¿Estás seguro de que deseas eliminar esta imagen? Esta acción no se puede deshacer.",
        typeLabels: {
            fuel: "Combustible",
            car_wash: "Lavado",
            repairs: "Reparaciones",
            maintenance: "Mantenimiento",
            parts: "Piezas de Repuesto",
            insurance: "Seguro",
            inspection: "Inspección",
            tyres: "Neumáticos",
            parking: "Estacionamiento",
            electricity: "Electricidad",
            taxes: "Impuestos",
            other: "Otro",
            info: "Información",
            service_maintenance: "Mantenimiento",
            service_repair: "Reparación",
            service_tuning: "Tuning",
        },
        serviceGroup: {
            name: "Servicio",
            selectSubtype: "Seleccionar tipo de servicio",
            maintenance: "Mantenimiento",
            repair: "Reparación",
            tuning: "Tuning",
        },
    },
    repeatingExpenses: {
        title: "Gasto Recurrente",
        repeatToggle: "Repetir este gasto",
        repeatFrequency: "Frecuencia",
        monthly: "Mensual",
        startDate: "Fecha de Inicio",
        nextDate: "La próxima entrada será generada",
        endDate: "Fecha de Fin",
        noEndDate: "Sin fecha de fin",
        copyOptions: "Opciones de Copia",
        copyTitle: "Copiar título del registro",
        copyLocation: "Copiar ubicación",
        copyDescription: "Copiar descripción",
        active: "Activo",
        status: "Estado",
        managedByRepeat: "Este gasto es parte de una secuencia recurrente.",
        placeholder: "Aquí puedes configurar la repetición automática para este gasto si ocurre regularmente con la misma cantidad.",
        deleteRepeat: "Eliminar Repetición",
        deleteRepeatConfirm: "¿Estás seguro de que deseas detener y eliminar esta secuencia recurrente? No se generarán futuras entradas. Las entradas pasadas permanecerán.",
        relatedEntries: "Entradas en esta secuencia",
        stopRepeat: "Detener repetición",
        isRepeating: "Repetitivo",
        noTerm: "Indefinidamente",
        until: "La última entrada será generada",
        summaryCopy: "El sistema copiará",
        simulate: "Simular generación de la próxima entrada",
        simulateSuccess: "Generación de la próxima entrada simulada con éxito",
        simulateNoDate: "No hay más fechas para generar (fecha final alcanzada)",
    },
    onboarding: {
        title: "Configurar Perfil",
        welcome: "¡Bienvenido!",
        subtitle: "Personaliza tu experiencia de conducción.",
        currency: "Moneda",
        preferredCurrency: "Moneda Preferida",
        distUnit: "Unidad de Distancia",
        volUnit: "Unidad de Volumen",
        complete: "Completar Configuración",
    },
    cars: {
        unitChangeWarningTitle: "Advertencia de Cambio de Unidad",
        unitChangeWarningMessage: "Cambiar estas unidades no convertirá tus datos existentes. Todos los registros históricos permanecerán exactamente como se ingresaron.",
        unitChangeWarningConfirm: "Entendido",
        title: "Garaje",
        carAdmins: "Administradores del Coche",
        sharedWithMe: "Compartido Conmigo",
        manageAdmins: "Gestionar Administradores",
        adminEmail: "Correo Electrónico del Administrador",
        addAdmin: "Agregar Administrador",
        addAdminPlaceholder: "p. ej. amigo@email.com",
        removeAdmin: "Eliminar",
        removeAdminConfirm: "¿Estás seguro de que deseas eliminar a este administrador?",
        adminAdded: "Administrador agregado",
        adminRemoved: "Administrador eliminado",
        removeMyAccess: "Eliminar mi acceso",
        removeMyAccessConfirm: "¿Estás seguro de que deseas renunciar al acceso a este coche?",
        myAccessRemoved: "Acceso eliminado",
        noAdminsYet: "No se han añadido administradores aún.",
        adminInfoText: "Los administradores pueden añadir y editar gastos, notas y piezas de repuesto, pero no pueden eliminar el coche en sí.",
        newCar: "Añadir Coche",
        carNotFound: "Coche No Encontrado",
        carNotFoundDesc: "El coche solicitado no existe o no tienes acceso.",
        accessDenied: "Acceso Denegado",
        accessDeniedDesc: "Este coche es privado y no está disponible públicamente.",
        backToHome: "Volver a Inicio",
        adminRestricted: "Acceso Restringido",
        adminRestrictedDesc: "Solo los administradores autorizados pueden acceder a esta consola. Por favor, regresa a la aplicación principal.",
        returnHome: "Regresar a Inicio",
        editCar: "Editar Coche",
        name: "Nombre del Coche",
        model: "Modelo",
        year: "Año",
        plate: "Número de Placa",
        vin: "Número VIN",
        mileage: "Kilometraje Actual",
        initialMileage: "Kilometraje Inicial",
        engineType: "Tipo de Motor",
        tapToChangeIcon: "Toca para cambiar el ícono",
        chooseIcon: "Elegir Ícono",
        imageTab: "Imagen",
        iconTab: "Ícono",
        chooseColor: "Elegir Color",
        chooseEmoji: "Elegir Emoji",
        uploadImage: "Subir Imagen",
        clickToBrowse: "Haz clic para explorar archivos",
        currentCarIcon: "Ícono del coche actual",
        changeImage: "Cambiar Imagen",
        zoom: "Acercar",
        rotate: "Rotar",
        removeChangeImage: "Eliminar / Cambiar Imagen",
        selectIcon: "Seleccionar Ícono",
        cropAndSave: "Recortar y Guardar",
        displayName: "Nombre para Mostrar",
        displayNamePlaceholder: "p. ej. Mi Coche de Fin de Semana",
        makeLabel: "Marca *",
        modelLabel: "Modelo *",
        yearLabel: "Año *",
        fuelTypeLabel: "Tipo *",
        licensePlateLabel: "Placa",
        vinLabel: "VIN",
        notesLabel: "Notas (opcional)",
        notesPlaceholder: "p. ej. 1.6 TDI, 85kW, 1588cc, batería 62kWh, AWD, etc.",
        publicAccess: "Hacer coche accesible públicamente",
        publicAccessDesc: "Otros pueden ver este coche a través de un enlace compartido",
        shareLocations: "Permitir ver también las ubicaciones añadidas",
        shareLocationsDesc: "Habilite esto para hacer visibles las ubicaciones del coche en vista pública",
        deleteCar: "Eliminar Coche",
        deleteCarTitle: "Eliminar Coche",
        deleteCarConfirm: "¿Estás seguro de que deseas eliminar '{name}'? Esta acción no se puede deshacer.",
        noCars: "No hay coches en tu garaje",
        addFirstCarNote: "Comienza tu viaje añadiendo tu primer vehículo para rastrear gastos.",
        addVehicle: "Añadir Un Vehículo",
        myVehicles: "Mis Vehículos",
        favorites: "Favoritos",
        deleteConfirm: "¿Estás seguro de que deseas eliminar este coche? Todos los gastos asociados serán eliminados.",
        deleteFailed: "Error al eliminar el coche",
        saveFailed: "Error al guardar los datos del coche",
        adminActions: "Acciones de Administrador",
        importCsv: "Importar CSV",
        clearData: "Borrar Datos",
        distanceUnitLabel: "Unidad de Distancia",
        volumeUnitLabel: "Unidad de Volumen",
        currencyLabel: "Moneda",
        boughtAt: "Fecha de Compra",
        purchasePrice: "Precio de Compra",
        purchaseMileage: "Kilometraje de Compra",
        createPurchaseRecord: "Crear registro de historial de compra automáticamente",
        makePlaceholder: "p. ej. BMW",
        modelPlaceholder: "p. ej. X5",
        platePlaceholder: "p. ej. AB-1234",
        vinPlaceholder: "VIN...",
        purchaseInfoNote: "Esta información creará un registro inicial de 'Información' en tu historial con los datos especificados.",
        availableTypes: "Tipos Disponibles",
        dragToReorder: "Arrastra para reordenar",
        requestTypeNote: "Si necesitas otro tipo - ",
        requestTypeAction: "¡háznoslo saber!",
        emailProcessingTitle: "Procesamiento de Correo Electrónico",
        emailInstructions: "Reenvía tus recibos a la dirección de abajo. Extraeremos datos y crearemos gastos automáticamente.",
        recentEmails: "Correos Electrónicos Recibidos",
        viewAllEmails: "VER TODOS ({count})",
        noEmailsReceived: "No se han recibido correos electrónicos aún.",
        analysisResult: "Resultado del Análisis",
        vehicleInfo: "Información del Vehículo",
        preferences: "Preferencias",
        purchaseHistory: "Historial de Compras",
        emailProcessing: "Procesamiento de Correo Electrónico",
        publicAccessTitle: "Acceso Público",
        expenseTypesTitle: "Tipos de Gastos",
        adminActionsTitle: "Acciones de Administrador",
        enterPurchaseDateAlert: "Por favor, introduce la fecha de compra",
        allowedSenderEmails: "Correos Electrónicos de Remitentes Permitidos",
        allowedEmailsDesc: "Añade direcciones de correo electrónico que están permitidas para enviar recibos a este coche. Máximo 5 direcciones.",
        noAllowedEmails: "No se han añadido correos electrónicos permitidos.",
        emailAlreadyAdded: "Este correo electrónico ya está permitido para este coche.",
        maxAllowedEmailsReached: "Se ha alcanzado el límite máximo de correos electrónicos permitidos.",
        addAllowedEmailPlaceholder: "Añadir correo electrónico permitido...",
        ownerEmail: "Propietario",
        onlyOwner: "solo propietario",
        defaultAllowed: "Siempre permitido",
        carLimitReachedTitle: "Límite de Coches Alcanzado",
        carLimitReachedMessage: "Tu plan {plan} permite {limit} coche(s). Ya tienes {current}. Ve a la configuración para ver tus límites o contáctanos para actualizar.",
        carLimitGoToSettings: "Ir a Configuración",
        archivedCars: "Archivados",
        archiveCar: "Archivar coche",
        unarchiveCar: "Desarchivar coche",
        sellDate: "Fecha de venta",
        sellPrice: "Precio de venta",
        sellMileage: "Kilometraje de venta",
        archiveConfirm: "¿Está seguro de que desea archivar este coche?",
        archiveInstructions: "Archivar un coche significa que ya no es suyo o que ya no lo mantiene. Por favor, proporcione los detalles de la venta para estadísticas. Esto hará que el coche sea de solo lectura. Los campos a continuación aún se pueden editar después.",
        archivedBadge: "Archivado",
        saleDetails: "Detalles de la venta",
        saleDetailsNote: "Los detalles de la venta se utilizan para estadísticas. Puede actualizarlos si es necesario.",
        archiveDetailsNotFillable: "Por favor, complete todos los campos para archivar el coche",
        emailAddressWillBeAvailableAfterSave: "La dirección de correo electrónico estará disponible después de guardar el coche.",
        proFeatureAdminTitle: "Función Pro: Administradores de coches",
        proFeatureAdminDesc: "Agrega otros usuarios que puedan ver y gestionar estos datos del coche.",
        proFeatureEmailTitle: "Función Pro: Remitentes adicionales",
        proFeatureEmailDesc: "Agrega otras direcciones de correo electrónico permitidas desde las cuales se pueden enviar recibos a este coche.",
        estimatedMileage: "Kilometraje estimado",
        summaryFrequencyLabel: "Frecuencia del resumen",
        summaryFrequencyOptions: {
            none: "Apagar",
            monthly: "Mensual",
            semiAnnually: "Semestral",
            annually: "Anual",
        },
        healthProfilePrompt: "¡Completa tu perfil de salud para un análisis preciso!",
    },
    fuelTypes: {
        not_specified: "-",
        petrol: "Gasolina",
        diesel: "Diésel",
        hybrid: "Híbrido",
        electric: "Eléctrico",
        lpg: "LPG",
    },
    statistics: {
        mileageTrend: "Tendencia de kilometraje",
        title: "Estadísticas",
        allYears: "Todos los años",
        totalSpent: "Total gastado",
        spentIn: "Gastado en {year}",
        perMonth: "por mes",
        overall: "global",
        vsPrev12m: "vs 12m prev.",
        rolling12m: "Últimos 12m",
        byType: "Por tipo",
        byMonth: "Por mes",
        byYear: "Por año",
        noData: "Sin datos para este año",
        mostExpensive: "Más caro",
        top: "Mejores",
        untitled: "Sin título",
        assetAnalysis: "Análisis de valor y costo de activos",
        burnNote: "* El 'Total quemado' incluye tanto el dinero gastado como la disminución estimada en el valor del coche.",
        carMarketValue: "Valor de mercado del coche",
        cumulativeCosts: "Costos acumulativos",
        totalBurn: "Total quemado (Costos + Depreciación)",
        entries: "entradas",
        avgPrice: "Precio promedio",
        consumption: "Consumo",
        price: "Precio",
        fuelPriceTrend: "Tendencia del precio del combustible",
        spendingTrend: "Tendencia de gastos",
        costPerKmTrend: "Costo por 1 km",
        costPerMileTrend: "Costo por 1 milla",
        serviceTrendsTitle: "Tendencias de Servicio",
        expensesOnMap: "Gastos en el mapa",
        visitsCountLabel: "visitas",
        locationsSummary: "Resumen de ubicaciones",
        locationsCountLabel: "lugares",
        noLocationsFoundTitle: "Sin ubicaciones aún",
        noLocationsFoundDesc: "Agregue ubicaciones a sus registros para verlas en el mapa.",
        addMileageData: "Agregar kilometraje",
        missingMileageInfo: "No hay suficientes datos para calcular el costo por distancia. Agrega al menos 2 lecturas de kilometraje en este período (o una antes de este período).",
        mileageModal: {
            title: "Agregar Kilometraje Faltante",
            description: "Para calcular con precisión los costos por distancia para {year}, necesitamos conocer el kilometraje al inicio y al final del año.",
            startOfYear: "Inicio del año (1 de enero)",
            endOfYear: "Fin del año (31 de diciembre)",
            currentMileage: "Kilometraje actual",
            placeholder: "Ingresa el kilometraje...",
            save: "Guardar Datos",
            foundNearby: "Encontrado cerca ({date}): {value} {unit}",
            useExisting: "Usar esto",
        },
        proAnalysis: "Análisis Pro",
        detailedAnalysis: "Análisis Detallado",
        upgradeToSee: "Actualiza para ver →",
    },
    tabs: {
        dashboard: "Tablero",
        expenses: "Gastos",
        stats: "Estadísticas",
        locations: "Ubicaciones",
        gallery: "Archivos",
        parts: "Piezas",
        notes: "Notas",
        repair: "Modo de reparación",
        'repair-switch': "Cambio de Coche",
    },
    repairAnalysis: {
        title: "Análisis de decisiones de reparación",
        ownershipLength: "Duración de Propiedad",
        currentValue: "Valor actual",
        valueOutdated: "El valor puede estar desactualizado",
        addValueToEnable: "Agregue el valor actual del coche para habilitar el análisis",
        totalInvested: "Total invertido",
        totalInvestedSub: "Precio de compra + reparaciones",
        totalExcludesFuel: "excluye combustible / electricidad",
        fuelLabelFuelOnly: "Total de combustible",
        fuelLabelEnergyOnly: "Total de energía",
        fuelLabelHybrid: "Total de combustible y energía",
        fuelTypeFuel: "combustible",
        fuelTypeEnergy: "electricidad",
        fuelTypeHybrid: "combustible y electricidad",
        fuelTotalLabel: "Total de combustible/energía:",
        projectionMode: "Modo de proyección",
        projectionModes: {
            lastYear: "Basado en el año pasado",
            average: "Promedio histórico",
            trend: "Tendencia (lineal)",
        },
        brakeAssumption: "El mantenimiento incluye un ciclo de frenos estimado de 3 años",
        repairBuffer: "Incluye un margen de riesgo de reparación basado en la edad",
        yearLabel: "año",
        totalInvestedDesc: "Precio de compra + todas las reparaciones",
        repairToValue: "Reparar al valor (12m)",
        repairToValueExplain: "Reparaciones €{cost} vs valor del coche €{value}. Por debajo del 20% es saludable; por encima del 50% es alto riesgo.",
        ownershipPressure: "Presión de propiedad",
        ownershipPressureExplain: "Presión total de costos: reparaciones €{cost} + pérdida de valor vs €{value}. Por encima del 35% indica estrés financiero.",
        investmentGap: "Brecha de inversión",
        investmentGapExplain: "Total invertido €{invested} menos valor actual €{value}. Esto muestra cuánto ha 'perdido' en propiedad hasta ahora.",
        investmentGapDesc: "Total invertido - valor actual",
        repairExpenses12m: "Costo de reparación de 12m",
        calculatedYearlyMileage: "Kilometraje anual calculado: {km} km",
        calculatedYearlyRepairs: "Reparaciones anuales calculadas: {amount}",
        set: "Establecer",
        plannedRepairCost: "Costo de reparación planificado",
        whatIfTitle: "¿Qué pasa si gastas {amount} ahora?",
        updatedScore: "Puntuación actualizada",
        updatedVerdict: "Veredicto actualizado",
        howIsItCalculated: "¿Cómo se calcula esto?",
        usedLifespan: "Usado: {usage}% de la vida útil esperada",
        remainingLifespan: "Restante: ~{km} km",
        estimatedLifespan: "Vida útil estimada: {km} km",
        lifecycle_stage_early: "Ciclo de vida temprano – bajo riesgo de fallos importantes",
        lifecycle_stage_mid: "Ciclo de vida medio – desgaste normal",
        lifecycle_stage_late: "Ciclo de vida tardío – mayor riesgo de reparaciones",
        lifecycle_stage_end: "Fin de la vida útil esperada – alto riesgo de reparaciones importantes",
        calculationExplanation: "El análisis utiliza el precio de compra de su vehículo, los costos de reparación recientes y el valor actual estimado para calcular una puntuación de salud financiera. Los altos costos de reparación en relación con el valor del coche o la rápida depreciación reducirán la puntuación.",
        confidenceLabel: "Confianza",
        confidenceLevel: {
            high: "Alta",
            medium: "Media",
            low: "Baja",
        },
        mentalFactorsTitle: "Mejore la precisión con su experiencia",
        mentalFactorsCTA: "Chequeo rápido (30 seg)",
        mentalFactorsSurveyTitle: "Su experiencia",
        mentalFactorsSurveyDesc: "Responda 3 preguntas rápidas para personalizar su puntuación.",
        q1: "¿Cumple tu coche con tus necesidades?",
        q1Help: "Espacio, comodidad, características",
        q2: "¿Disfrutas conducir tu coche?",
        q2Help: "Visual, comodidad, sensación",
        q3: "¿Te preocupa las averías inesperadas?",
        q3Help: "Preocupaciones de fiabilidad",
        q4: "¿Es este coche para la familia y viajes largos?",
        q4Help: "Prioridad en seguridad y fiabilidad",
        factorsTitle: "Factores de Puntuación",
        factorsDesc: "Ve qué impacta tu puntuación",
        newCarComparison: "Comparación de Coche Nuevo",
        newCarComparisonDesc: "Compara tu costo mensual actual con la compra de un coche nuevo.",
        modeLeasing: "Leasing",
        modeFullPrice: "Precio Total",
        downPayment: "Pago Inicial",
        leaseYears: "Plazo (Años)",
        monthlyPayment: "Pago Mensual",
        carPrice: "Precio Total del Coche",
        ownershipYears: "Propiedad Planificada (Años)",
        insuranceMonthly: "CASCO / Seguro Mensual",
        currentMonthlyCost: "Costo Actual del Auto",
        newCarMonthlyCost: "Costo del Coche Nuevo",
        newCarCheaper: "El coche nuevo es más barato en: {amount} / mes",
        newCarMoreExpensive: "El coche nuevo es más caro en: {amount} / mes",
        newCarSameCost: "Los costos son exactamente los mismos.",
        advancedSettings: "Configuraciones Avanzadas",
        yearlyMaint: "Mantenimiento Anual (€)",
        tyres3Yrs: "Neumáticos / 3 años (€)",
        depreciation5Yrs: "Depreciación (5 años %)",
        newCarYear: "Año del Coche Nuevo",
        cumulativeCosts: "Costos Acumulativos (Proyección)",
        comparisonByYear: "Comparación por Año",
        currentCarLabel: "Coche Actual",
        newCarLabel: "Coche Nuevo",
        resaleValue: "Valor de Reventa",
        startupCosts: "Costos Iniciales (Coche Usado)",
        inspection: "Inspección previa a la compra",
        initialMaintenance: "Mantenimiento inicial + aceites",
        registration: "Registro / Tarifas",
        total: "Total",
        currentCarTitle: "Coche Actual",
        newCarTitle: "Coche Potencial",
        upfrontInvestment: "Inversión Inicial",
        monthlyReality: "Costo Mensual Real",
        depreciationShort: "Depreciación",
        howCalculated: "¿Cómo se calcula esto?",
        deltaMonthly: "Diferencia mensual",
        deltaUpfront: "Diferencia inicial",
        surveyMeanings: {
            practical: {
                1: "En absoluto",
                2: "Mala adaptación",
                3: "Promedio",
                4: "Buena adaptación",
                5: "Perfecta adaptación",
            },
            joy: {
                1: "Frustrante",
                2: "Aburrido",
                3: "Promedio",
                4: "Disfrutable",
                5: "Mucho",
            },
            worry: {
                1: "No preocupado",
                2: "Ligeramente preocupado",
                3: "Preocupado",
                4: "Muy preocupado",
                5: "Seguro de que me descompondré en cualquier momento",
            },
        },
        verdicts: {
            KEEP: "Financieramente razonable mantener",
            borderline: "Límite – monitorear de cerca",
            sell: "Alto riesgo financiero – vender puede ser racional",
        },
        factors: {
            trendInc: "Tendencia en Aumento",
            trendIncDesc: "Los costos de reparación están creciendo en comparación con el año pasado.",
            lowDepreciation: "Ventaja de Baja Depreciación",
            lowDepreciationDesc: "Los coches más viejos/baratos pierden menos valor con el tiempo.",
            stableRepairs: "Reparaciones Estables",
            stableRepairsDesc: "Tus costos de reparación son estables o están disminuyendo.",
            noHistoricalData: "No hay datos más antiguos de 6 meses.",
            lifecycle_stage: "Etapa del ciclo de vida del vehículo",
            high_risk_phase: "Fase de alto riesgo",
            high_risk_phase_desc: "La combinación de una etapa tardía del ciclo de vida y el aumento de los costos de reparación indica alto riesgo.",
            lowCostKm: "Costo Eficiente por KM",
            lowCostKmDesc: "La eficiencia general de operar este coche es excelente.",
            lowFixedCosts: "Bajos Costos Fijos",
            lowFixedCostsDesc: "Tus costos fijos (impuestos, seguro) son bajos.",
            usage: "Uso Anual",
            usageDesc: "Distancia recorrida en los últimos 12 meses.",
            accidentMinor: "Accidente Menor",
            accidentMinorDesc: "Daños estéticos o pequeñas reparaciones.",
            structuralDamage: "Daño Estructural",
            structuralDamageDesc: "Problemas en el marco o estructurales reducen drásticamente el valor.",
            aiLifespanNearEnd: "Fin de la Vida Útil Esperada",
            aiLifespanAging: "Componentes Envejecidos",
            aiLifespanGood: "Ventaja de Bajo Kilometraje",
            aiLifespanDesc: "Basado en la vida útil típica estimada por IA para este modelo.",
            aiUpcomingRepairs: "Reparaciones Próximas (Predicción IA)",
            aiUpcomingRepairsDesc: "La IA predice fallos importantes de componentes pronto basado en el kilometraje.",
            ownershipFatigue: "Fatiga de Propiedad",
            ownershipFatigueLong: "La propiedad a largo plazo a menudo lleva a una preparación mental para un vehículo diferente.",
            ownershipFatigueShort: "El sesgo de propiedad inicial crea una tendencia más fuerte a mantener el coche.",
            family_priority: "Familia y Viajes Largos",
            replacement_comparison: "Comparación de Reemplazo",
            none: "Ninguno",
            surface: "Superficie",
            minor: "Menor",
            moderate: "Moderado",
            severe: "Severo",
            structural: "Estructural",
            major: "Mayor",
            critical: "Crítico",
            full: "Completo",
            improveLabel: "¿Qué mejoraría esto?",
            info_original_price: "El precio aproximado de este coche cuando era nuevo. Ayuda a estimar la estabilidad del valor. Los coches más antiguos con menor valor restante son más seguros financieramente.",
            info_current_value: "Cuánto podrías venderlo hoy. Se utiliza para verificar si las reparaciones son un gran porcentaje del valor del coche, lo que indica una mala inversión.",
            info_yearly_mileage: "Un mayor kilometraje aumenta el desgaste. Un bajo kilometraje puede extender significativamente la vida del coche.",
            info_estimated_repairs: "Costo continuo de mantener el coche en funcionamiento. Altos costos anuales reducen la atractivo de mantener el coche.",
            info_planned_repairs: "Reparaciones conocidas que se avecinan. Simula presión inmediata sobre tu decisión.",
            info_ownership_years: "¿Cuánto tiempo has tenido este coche? Esto afecta la fatiga psicológica de propiedad y el sesgo del comprador inicial.",
            info_rust: "Riesgo crítico a largo plazo. La oxidación estructural reduce la seguridad. La oxidación severa hace que vender sea una mejor opción.",
            info_crashes: "Accidentes estructurales afectan la seguridad y la fiabilidad. También reducen significativamente el valor de reventa.",
            info_repaint: "Indica daños pasados o arreglos estéticos. Impacto pequeño a menos que se oculten problemas más profundos.",
            info_unresolved: "Costos futuros ocultos. Fallos conocidos en electrónica, motor o mantenimiento que necesitan atención.",
            info_fit: "¿El coche se adapta a tus necesidades (espacio, comodidad)? Un mal ajuste significa que es más probable que lo reemplaces.",
            info_joy: "El valor emocional importa. Sin alegría significa que estás mentalmente listo para un coche nuevo.",
            info_worry: "Estrés percibido por la fiabilidad. Alta preocupación es una señal fuerte para reemplazar el coche.",
        },
        explanations: {
            repairFreq: "Tu coche tuvo {visits} visitas de servicio en los últimos 12 meses. Las visitas frecuentes indican menor fiabilidad y mayor inconveniente.",
            repairVsValue: "En los últimos 12 meses, tus reparaciones costaron €{cost}, mientras que el valor estimado del coche es €{value}. Eso es el {ratio}% del valor total del coche.",
            stableRepairsDetailYearly: "El año pasado gastaste €{cost1} en reparaciones, pero el año anterior €{cost2}. Cambio de {percent}% ({trend}).",
            stableRepairsDetailHalfYearly: "En los últimos 6 meses gastaste €{cost1}, en los 6 meses anteriores €{cost2}. Cambio de {percent}% ({trend}).",
            mileage: "Con {mileage} km, el coche entra en una zona de mayor riesgo para fallos importantes de piezas (transmisión, componentes del motor).",
            planned: "Tienes €{cost} en reparaciones planificadas, lo que reduce inmediatamente la seguridad financiera de mantener el coche.",
            lowDep: "Los coches valorados alrededor de €{value} pierden muy poco valor por año, contrarrestando los costos de reparación más altos.",
            depRisk: "Tu coche tiene {age} años y ha completado mayormente su ciclo de depreciación, lo que significa que no pierdes dinero por la caída de su valor.",
            stable: "Gastaste €{costThisYear} este año frente a €{costLastYear} el año pasado, lo que representa una disminución del {percent}%. Los costos predecibles son matemáticamente favorables.",
            costKm: "Condujiste {km} km el año pasado. Los costos de operación fueron de €{costKm} por kilómetro, lo que muestra una excelente eficiencia económica.",
            fixedCosts: "Pagaste €{costs} en costos fijos anuales (seguro/impuesto). Esta baja huella brinda tranquilidad adicional.",
            usage: "Conduces alrededor de {km} km por año según tus registros.",
            practical_fit: "Evaluaste el ajuste práctico en {score}/5, ajustando la puntuación matemática en {impact} puntos.",
            emotional_satisfaction: "Evaluaste tu satisfacción emocional en {score}/5, ajustando la puntuación en {impact} puntos.",
            reliability_anxiety: "Tu confianza en la fiabilidad es de {score}/5, impactando la puntuación en {impact} puntos.",
            rust: "El óxido estructural severo o en la parte inferior típicamente significa peligros de seguridad o escenarios de baja.",
            accident: "Los daños anteriores, dependiendo de la gravedad, reducen inherentemente el valor de reventa y la seguridad del vehículo.",
            structural: "Los problemas estructurales hacen que el coche sea financieramente peligroso automáticamente.",
            ai_lifespan: "A {current} km, el coche ha completado el {ratio}% de su vida útil estimada por la IA ({expect} km).",
            ai_repairs: "Los datos de la IA indican que a este kilometraje tienden a ocurrir {count} reparaciones importantes típicas específicas del modelo.",
            lifecycle_stage: "¿Qué significa la vida útil? {total} km – este es el punto predicho por la IA cuando típicamente comienzan las reparaciones estructurales importantes (motor, caja de cambios, etc.) para este modelo. No es el final de la vida del coche – el coche aún puede conducir, pero con costos de mantenimiento significativamente más altos. La vida física completa de un coche típico es de 500k–1M km, pero se vuelve económicamente inviable mucho antes.",
        },
        ratios: {
            healthy: "Saludable",
            monitor: "Monitorear",
            highRisk: "Alto riesgo",
            stable: "Estable",
            warning: "Advertencia",
            financialStress: "Estrés financiero",
        },
        proFeatureTitle: "Función Pro: Modo de Reparación",
        proFeatureDesc: "Desbloquea el motor de decisiones para obtener un análisis financiero profesional de las reparaciones de tu vehículo. Los usuarios gratuitos ven una demostración con datos de muestra.",
        viewDemo: "Ver Demostración en Vivo",
        upgradeToUnlock: "Actualiza a PRO para analizar tu coche",
    },
    carTasks: {
        title: "Tareas del Coche",
        placeholderTitle: "Seguimiento de Mantenimiento",
        placeholderDesc: "Programa de mantenimiento para el modelo de su coche.",
        demoTitle: "Tareas de Mantenimiento del Coche",
        demoSubtitle: "Seguimiento inteligente para su vehículo",
        feature1Title: "Generación Automática de Tareas",
        feature1Desc: "Genera automáticamente tareas como cambios de aceite, reemplazos de filtros y revisiones de la correa de distribución según el modelo de su coche.",
        feature2Title: "Integración de Gastos",
        feature2Desc: "Analiza su historial de servicio para entender qué se ha hecho y cuándo.",
        feature3Title: "Recordatorios Inteligentes",
        feature3Desc: "Reciba notificaciones basadas tanto en el tiempo como en el kilometraje. El seguimiento se restablece automáticamente cuando marca una tarea como completada.",
        getStarted: "Comenzar",
        fakeDoorPopupTitle: "Comentarios Bienvenidos",
        fakeDoorPopupMessage: "Actualmente estamos desarrollando tareas de mantenimiento del coche. Esta función le permitirá seguir los intervalos de servicio automáticamente. ¿Qué tareas o funciones específicas le gustaría ver más?",
        fakeDoorPopupPlaceholder: "Sus pensamientos...",
        noTasksYet: "No hay tareas aún",
        deleteAllTitle: "¿Limpiar la lista de tareas?",
        deleteAllMessage: "¿Estás seguro de que deseas eliminar todas las {count} tareas para este coche? Esta acción no se puede deshacer.",
        deleteAllSuccess: "Todas las tareas han sido eliminadas con éxito.",
        sortPriority: "Prioridad",
        sortType: "Tipo",
        sortDate: "Más reciente",
        status: {
            overdue: "VENCIDO",
            pending: "PENDIENTE",
            noData: "SIN DATOS",
            upcoming: "Próximo",
            nextIn: "Próximo en {dist} {unit}",
            overdueBy: "{dist} {unit} vencido",
            afterDays: "En {days} días",
            overdueDays: "{days} días vencido",
        },
        form: {
            newTitle: "Nueva Tarea",
            actionType: "¿Inspeccionar o Reemplazar?",
            intervalMonths: "Intervalo (Meses)",
            intervalDistance: "Intervalo (Distancia)",
            diffFirstInterval: "El primer intervalo difiere del intervalo base",
            firstInterval: "Primer Intervalo",
            historyToggle: "¿Se ha realizado alguna vez esta tarea para este coche?",
            historyToggleDesc: "Si NO, asumimos que nunca se ha hecho desde la producción.",
            lastPerformedOptional: "¿Cuándo se realizó por última vez? (Opcional)",
            deleteTitle: "Eliminar Tarea",
            deleteConfirm: "¿Estás seguro de que deseas eliminar esta tarea?",
            saveError: "Error al guardar la tarea",
            historyConfirmed: "Historial Confirmado",
            reminders: "Recordatorios",
            notifyMileage: "Notificarme cuando se alcance el kilometraje estimado",
            notifyDate: "Notificarme cuando se alcance la fecha",
            nextMileageReminder: "Fecha estimada",
            nextDateReminder: "Fecha de vencimiento",
            estimatedDate: "Fecha estimada",
            missingLastMileage: "Falta el último kilometraje realizado",
            missingLastDate: "Falta la última fecha realizada",
            missingStartDate: "No se pudo determinar la fecha de inicio",
            additionalOptions: "Opciones Adicionales",
            reminderInfoMissing: "Estado informativo: los recordatorios están desactivados hasta que se proporcionen los datos de la última realización.",
        },
    },
    dashboard: {
        title: "Tablero",
        quickActions: "Acciones Rápidas",
        addExpense: "Agregar Gasto",
        editCar: "Editar Coche",
        recentExpenses: "Gastos",
        seeAll: "Ver Todo",
        recentGallery: "Archivos",
        thisMonth: "Este Mes",
        totalSpent: "Total Gastado",
        avgPerMonth: "Promedio/Mes",
        recentNotes: "Notas",
        recentParts: "Piezas",
        noRecentExpenses: "No hay gastos recientes",
        noRecentGallery: "No hay fotos recientes",
        noRecentNotes: "No hay notas recientes",
        noRecentParts: "No hay piezas recientes",
        createNote: "Crear Nuevo",
        createPart: "Crear Nuevo",
        createExpense: "Crear Nuevo",
        noFiles: "No se han añadido archivos aún",
        needSomethingMore: "¿Necesitas algo más?",
        letUsKnow: "¡háznoslo saber!",
    },
    expenseTypes: {
        editTitle: "Editar Tipo de Gasto",
        newTitle: "Nuevo Tipo de Gasto",
        categoryName: "Nombre de la Categoría",
        placeholderName: "p. ej. Servicio",
        signatureColor: "Color de Firma",
        icon: "Ícono de Categoría",
        deleteConfirm: "¿Estás seguro de que deseas eliminar el tipo '{name}'?",
    },
    spareParts: {
        title: "Piezas de Repuesto",
        connectedWithRecords: "Conectado con Registros",
        toBuy: "Por Comprar",
        usedInExpenses: "Usado en Gastos",
        noPartsToBuy: "No se han agregado piezas a la lista de compras",
        noPartsUsed: "No hay piezas vinculadas a gastos aún",
        quantity: "Cant",
        partCode: "Código de Pieza",
        price: "Precio",
        link: "Enlace",
        comment: "Comentario",
        addPart: "Agregar Pieza de Repuesto",
        editPart: "Editar Pieza de Repuesto",
        openPart: "Abrir entrada de Pieza",
        nameLabel: "Nombre",
        manufacturerLabel: "Fabricante",
        priceLabel: "Precio ({currency})",
        imagesLabel: "Archivos",
        linkedHistory: "Historial Vinculado",
        partManagedNote: "Esta pieza se gestiona a través de un gasto",
        cannotDeleteNote: "Dado que esta pieza está vinculada a un gasto, no se puede eliminar por separado. Elimina o edita el gasto para gestionar el ciclo de vida de esta pieza.",
        partNamePlaceholder: "Nombre de la pieza...",
        manufacturerPlaceholder: "Bosch, Brembo, etc.",
        additionalInfoPlaceholder: "Información adicional...",
        namePlaceholder: "p. ej. Pastillas de Freno",
        codePlaceholder: "p. ej. 5Q0 698 151",
        linkPlaceholder: "https://...",
        vinPlaceholder: "WBADT...",
        savePart: "Guardar Pieza",
        deletePart: "Eliminar pieza de repuesto",
        deleteConfirm: "¿Estás seguro de que deseas eliminar esta pieza de repuesto?",
        sparePartsLabel: "Piezas de Repuesto",
        partNumber: "Pieza #{number}",
        imagesLimitLabel: "Archivos (hasta 5)",
        optional: "(opcional)",
        selectPart: "Seleccionar Pieza de Repuesto",
        createNew: "Crear nueva pieza de repuesto",
        searchPlaceholder: "Buscar por nombre o código...",
        noResults: "No se encontraron piezas",
        noPartsYet: "No hay piezas aún. ¡Crea la tuya primera!",
        selectorDescription: "Encuentra y selecciona una pieza de repuesto existente, o crea una nueva",
        alreadyAdded: "Esta pieza ya está añadida",
        statistics: {
            avgPrice: "Promedio",
            lastPrice: "Último",
            usedTimes: "Usado {count} veces",
            totalPurchased: "Total: {quantity}x",
        },
        usage: {
            title: "Esta Compra",
            quantity: "Cantidad",
            pricePerUnit: "Precio por unidad",
            comment: "Comentario",
            commentPlaceholder: "p. ej., Comprado en AutoZone",
            total: "Total",
            transactionData: "Esta Transacción",
        },
        masterData: "Información Principal de la Pieza",
        masterRecord: {
            title: "Detalles de la Pieza (compartido)",
            editMaster: "Editar Registro Maestro",
            warning: "Los cambios en el registro maestro afectan todos los usos",
        },
    },
    reminders: {
        title: "Recordatorios",
        reminder: "Recordatorio",
        noteReminder: "Recordatorio de Nota",
        partReminder: "Recordatorio de Parte",
        today: "Hoy",
        tomorrow: "Mañana",
        yesterday: "Ayer",
        inXDays: "en {x} días",
        xDaysAgo: "hace {x} días",
        inXMonths: "en {x} meses",
        xMonthsAgo: "hace {x} meses",
        active: "Activo",
        activeDesc: "Si es necesario, puede desactivar este recordatorio sin eliminarlo",
        disabled: "Desactivado",
        yearly: "Anual",
        markSeen: "Reconocer",
        addReminder: "Nuevo Recordatorio",
        editReminder: "Editar Recordatorio",
        extraReminders: "Recordatorios Adicionales",
        extraRemindersDesc: "Enviar 3 recordatorios más en los siguientes días (4 en total) si no se detiene.",
        remindDate: "Fecha",
        remindTime: "Hora",
        repeatYearly: "Repetir Anualmente",
        repeatYearlyDesc: "Este recordatorio ocurrirá automáticamente cada año en la misma fecha/mes/día/hora hasta que se desactive",
        standalone: "Recordatorios Independientes",
        embedded: "Recordatorios Vinculados",
        noReminders: "No hay recordatorios activos",
        deleteReminder: "Eliminar Recordatorio",
        nameLabel: "Nombre",
        descriptionLabel: "Descripción",
        namePlaceholder: "Nombre del recordatorio",
        descriptionPlaceholder: "Descripción corta o nota",
        simulateReminder: "Simular momento del recordatorio",
        simulateSuccess: "Correo de simulación enviado",
        timezone: "Zona horaria",
        nextReminder: "Próximo recordatorio",
        futureTimeError: "La hora del recordatorio debe estar en el futuro",
    },
    notes: {
        title: "Notas",
        emptyNote: "Nota vacía",
        noNotes: "No hay notas aún",
        addNote: "Agregar Nota",
        editNote: "Editar Nota",
        viewNote: "Ver Nota",
        openNote: "Abrir entrada de Nota",
        titleLabel: "Título",
        contentLabel: "Contenido",
        noteTitlePlaceholder: "Título de la nota...",
        noteContentPlaceholder: "Escribe tu nota aquí...",
        saveNote: "Guardar Nota",
        deleteNote: "Eliminar Nota",
        publicNote: "Hacer nota pública",
        publicNoteDesc: "Otros pueden ver esta nota a través del enlace compartido",
        deleteConfirm: "¿Estás seguro de que deseas eliminar esta nota?",
        enterTitleAlert: "Por favor, ingresa un título",
        saveFailed: "Error al guardar la nota",
        thisNote: "Esta nota",
        deleteFailed: "Error al eliminar la nota",
        pinToTop: "Fijar en la parte superior",
    },
    locations: {
        title: "Ubicaciones",
        singleTitle: "Ubicación",
        newLocation: "Nueva Ubicación",
        emptyLocation: "Ubicación vacía",
        noLocations: "Para estadísticas - puedes agregar la ubicación donde ocurrió este gasto del coche",
        addLocation: "Agregar Ubicación",
        editLocation: "Editar Ubicación",
        viewLocation: "Ver Ubicación",
        openLocation: "Abrir Ubicación",
        createNew: "Crear nueva ubicación",
        selectLocation: "Seleccionar ubicación",
        searchLocations: "Buscar ubicaciones...",
        nameLabel: "Nombre",
        addressLabel: "Dirección o Coordenadas",
        descriptionLabel: "Comentario/Descripción",
        namePlaceholder: "p. ej., Servicio del Centro",
        mapLabel: "Ubicación",
        searchPlaceholder: "Buscar dirección...",
        addressPlaceholder: "Ingresa dirección y selecciona...",
        descriptionPlaceholder: "Información adicional...",
        fillAddress: "Completar dirección desde el mapa",
        saveLocation: "Guardar Ubicación",
        deleteLocation: "Eliminar ubicación",
        deleteConfirm: "¿Estás seguro de que deseas eliminar esta ubicación?",
        enterNameAlert: "Por favor, ingresa un nombre",
        saveFailed: "Error al guardar la ubicación",
        thisLocation: "Esta ubicación",
        deleteFailed: "Error al eliminar la ubicación",
        myLocations: "Mis Ubicaciones",
        usedInEntries: "Usado en entradas",
        noEntries: "La ubicación no está en uso",
        noEntriesThisCar: "Esta ubicación no ha sido utilizada para este coche",
        removeLocation: "Eliminar ubicación",
        noResults: "No se encontraron resultados",
    },
    gallery: {
        title: "Archivos",
        noImages: "No se han agregado imágenes",
        addImagesNote: "Agregar imágenes al coche o gastos",
        totalImages: "Total de {count} imágenes",
        imageAlt: "Imagen {number}",
        commentPlaceholder: "Comentario del archivo",
        isReceipt: "Este archivo es un recibo",
        deleteImageTitle: "Eliminar archivo",
        deleteImageConfirm: "¿Está seguro de que desea eliminar este archivo permanentemente?",
    },
    search: {
        placeholder: "Buscar gastos, piezas, notas...",
        typeToSearch: "Escribe para comenzar a buscar",
        noResults: "No se encontraron resultados para '{query}'",
        carImage: "Imagen del Coche",
        expenseImage: "Imagen del Gasto",
        noteImage: "Imagen de la Nota",
        galleryImage: "Imagen de la Galería",
        untitledExpense: "Gasto Sin Título",
    },
    landing: {
        nav: {
            features: "Funcionalidades",
            howItWorks: "Cómo funciona",
            pricing: "Precios",
            login: "Iniciar sesión",
            getStarted: "Empezar",
            garage: "Garaje",
        },
        hero: {
            title: "Conoce Exactamente Lo Que Tu Coche",
            subtitle: "Realmente Cuesta",
            description: "Rastrea gastos, registra reparaciones y ve a dónde va realmente tu dinero.",
            subheadline: "El panel de control profesional basado en datos para propietarios de coches meticulosos.",
            startTracking: "Empezar",
            viewDemo: "Demo de Coche ->",
            trustSignal: "Únete a más de 1,200 propietarios meticulosos que ya han mapeado más de 5 millones de kilómetros de costos reales de coches.",
            ctaNote: "Sin tarjeta de crédito. Sin ventas agresivas. Solo claridad.",
            benefits: {
                repairVsSell: {
                    title: `Reparar vs. Vender`,
                    description: `Identifica el umbral de "Reparar vs. Vender" — Deja de preguntarte si estás invirtiendo dinero en un pozo sin fondo. Conoce el momento exacto en que una reparación ya no es una inversión inteligente.`
                },
                costPerKm: {
                    title: `Costo por KM`,
                    description: `Rastrea tu costo real por kilómetro — Ve más allá del panel de control. Observa la imagen financiera completa de tus hábitos de conducción que otras aplicaciones omiten.`
                },
                automation: {
                    title: `Automatización`,
                    description: `Automatiza tu registro — Simplemente reenvía tus facturas o envía tus notas por correo electrónico. Nuestra IA organiza la historia técnica de tu coche por ti.`
                }
            },
        },
        features: {
            title: "Todo lo que necesitas para gestionar tu coche",
            subtitle: "Deja de usar hojas de cálculo y carpetas desordenadas. My Car Costs trae herramientas profesionales de gestión de flotas a tu garaje personal.",
            expenseTracking: {
                title: "Seguimiento de Gastos",
                description: "Registra combustible, servicio, seguro y reparaciones. Categoriza costos y visualiza tendencias de gasto a lo largo del tiempo.",
            },
            spareParts: {
                title: "Gestor de Piezas de Repuesto",
                description: "Mantén un inventario detallado de piezas de repuesto, números de parte y notas de compatibilidad para todas tus reparaciones.",
            },
            serviceHistory: {
                title: "Historial de Servicio y Notas",
                description: "Mantén un libro de servicio digital. Agrega notas detalladas sobre mantenimiento, modificaciones o planes futuros.",
            },
            documentStorage: {
                title: "Almacenamiento de Documentos",
                description: "Sube recibos, facturas y fotos de tu coche. Mantén toda tu documentación segura y accesible.",
            },
            emailForwarding: {
                title: "Reenvío de Correos",
                description: "Reenvía facturas directamente a tu bandeja de entrada única. Extraeremos los datos y los agregaremos automáticamente a tu panel.",
            },
            multiCar: {
                title: "Garaje Multi-Coche",
                description: "Gestiona un coche o toda una flota. Cambia entre vehículos al instante y ve estadísticas agregadas.",
            },
            repeatingExpenses: {
                title: "Gastos Repetidos",
                description: "Automatiza el seguimiento de costos mensuales regulares como seguros, estacionamiento o leasing.",
            },
            smartReminders: {
                title: "Recordatorios Inteligentes",
                description: "Configura alertas personalizadas para piezas de repuesto y notas de servicio para no perderte ninguna tarea de mantenimiento.",
            },
        },
        howItWorks: {
            title: "Flujo de trabajo simple y poderoso",
            step1: {
                title: "Agrega tu vehículo",
                description: "Ingresa los detalles de tu coche para crear tu garaje digital.",
            },
            step2: {
                title: "Registra gastos y archivos",
                description: "Toma una foto de un recibo o reenvía un correo. Nosotros nos encargamos del resto.",
            },
            step3: {
                title: "Obtén información",
                description: "Ve tu costo por kilómetro, gasto mensual y cronograma de mantenimiento.",
            },
        },
        useCases: {
            title: "Perfecto para",
            enthusiasts: {
                title: "Entusiastas de los Coches",
                description: "Rastrea cada modificación, número de parte e intervalo de mantenimiento para tu coche de proyecto.",
            },
            dailyDrivers: {
                title: "Conductores Diarios",
                description: "Sabe exactamente cuánto cuesta tu viaje y nunca te pierdas una fecha de servicio.",
            },
            flippers: {
                title: "El Flipper Inteligente",
                description: "Construye un volumen verificable de datos que demuestre el verdadero valor de tu coche a los compradores.",
            },
            fleets: {
                title: "Pequeñas Flotas",
                description: "Gestiona múltiples vehículos de la empresa en un solo lugar sin la sobrecarga de software empresarial.",
            },
        },
        foundersNote: {
            title: "Nota del Fundador",
            content: "Estoy construyendo MyCarCosts para ser la herramienta definitiva para las personas que realmente se preocupan por sus coches. ¿Falta alguna función en tu flujo de trabajo? Contáctame directamente. Si tiene sentido para la comunidad, lo construiremos juntos.",
        },
        pricing: {
            freeLimitedTime: "Gratis por tiempo limitado",
            title: "Precios simples y transparentes",
            subtitle: "Comienza gratis, mejora a medida que creces.",
            perMonth: "mes",
            monthly: "Mensual",
            yearly: "Anual",
            save25: "Ahorra 25%",
            billedAnnually: "Facturado anualmente ({amount})",
            free: {
                title: "Gratis",
                cta: "Comenzar",
            },
            pro: {
                title: "Pro",
                cta: "Actualizar a Pro",
                recommended: "Recomendado",
                earlyAdopter: "Precio para primeros usuarios",
                priceLock: "Bloquea este precio ahora. El precio puede aumentar en el futuro.",
            },
            custom: {
                title: "Personalizado",
                cta: "Contáctanos",
            },
            features: {
                oneCar: "1 coche",
                unlimitedExpenses: "Gastos ilimitados",
                unlimitedSpareParts: "Piezas de repuesto ilimitadas",
                unlimitedNotes: "Notas ilimitadas",
                repeatedExpenses: "Gastos repetidos",
                emailReminders: "Notas y recordatorios de piezas de repuesto por correo electrónico",
                basicStatistics: "Estadísticas básicas",
                fullStatistics: "Estadísticas completas",
                storage50mb: "Almacenamiento de archivos de 50 Mb",
                unlimitedArchivedCars: "Coches archivados ilimitados",
                dataExport: "Exportación de datos",
                allInFreePlus: "todo en gratis plus:",
                threeCars: "Hasta 3 coches",
                storage2gb: "Almacenamiento de archivos de 2 Gb",
                emailParsing: "Análisis de correo electrónico",
                carAdmins: "Administradores de coches",
                moreCars: "Más coches",
                moreFileStorage: "Más almacenamiento de archivos",
                customRequirements: "Requisitos personalizados",
            },
            upgradePopup: {
                title: "¡Próximamente!",
                message: "Las versiones pro y personalizadas aún no se han lanzado, pero lo harán pronto. Para ayudarnos a lanzar más rápido, por favor anota qué función específica esperas de la versión pro / personalizada, o cualquier otra cosa que te gustaría que mejoráramos para hacer esta plataforma aún mejor para ti.",
                placeholder: "Escribe tus comentarios aquí...",
                submit: "Enviar",
                cancel: "Cancelar",
                thanksTitle: "¡Gracias!",
                thanksMessage: "Hemos recibido tus comentarios y trabajaremos para hacer que MyCarCosts sea aún mejor.",
                thanksOk: "Ok",
            },
        },
        migration: {
            title: "¿Migrando desde Excel u otra aplicación?",
            subtitle: "Ofrecemos un servicio profesional de migración de datos para que puedas comenzar a funcionar al instante.",
            pricingModel: "Modelo de precios",
            small: {
                title: "Conjunto de datos pequeño",
                description: "< 500 filas",
                price: "€19–29",
            },
            medium: {
                title: "Conjunto de datos mediano",
                description: "500–5,000 filas",
                price: "€49",
            },
            large: {
                title: "Grande / Desordenado",
                description: "Sistemas heredados o archivos complejos",
                price: "Cotización personalizada",
            },
            process: {
                title: "Cómo funciona",
                step1: "Envías tu archivo",
                step2: "Evaluamos los datos",
                step3: "Pago único",
                step4: "Nosotros manejamos la importación",
            },
            cta: "Solicitar Migración",
        },
        repairAnalysisSection: {
            title: "¿Reparar o vender? Deja que los datos decidan.",
            subtitle: "Análisis financiero profesional para tu vehículo. Deja de adivinar y comienza a saber si esas reparaciones realmente valen la pena.",
            features: {
                personalized: {
                    title: "Análisis Personalizado",
                    description: "Para tus coches registrados, utilizamos gastos y parámetros históricos reales, añadiendo costos planificados para generar una evaluación.",
                },
                public: {
                    title: "Simulador Público",
                    description: "¿Evaluando una compra potencial? Utiliza nuestra herramienta pública en /repair para generar un análisis detallado ingresando solo algunos datos clave.",
                },
                whatIf: {
                    title: "Simulador de Qué Pasaría Si",
                    description: "Ingresa un costo de reparación planificado y ve instantáneamente cómo afecta la puntuación financiera de tu coche.",
                },
            },
            cta: "Ver Análisis de Muestra",
        },
        faq: {
            title: "Preguntas Frecuentes",
            subtitle: "Todo lo que necesitas saber sobre My Car Costs",
            questions: {
                mobileApps: {
                    question: "¿Habrá aplicaciones para iOS y Android?",
                    answer: "¡Sí! Las aplicaciones móviles para iOS y Android llegarán pronto. Estamos trabajando arduamente para ofrecerte la mejor experiencia móvil.",
                },
                dataPrivacy: {
                    question: "¿Mis datos son privados y seguros?",
                    answer: "Absolutamente. Tus datos están encriptados y almacenados de forma segura. Solo tú puedes acceder a la información de tu coche a menos que elijas explícitamente hacerlo público.",
                },
                freePlan: {
                    question: "¿El plan gratuito es realmente gratuito para siempre?",
                    answer: "¡Sí! El plan gratuito siempre estará disponible con un coche y todas las funciones esenciales. Puedes actualizar a Pro en cualquier momento para hasta 3 coches y funciones avanzadas.",
                },
                dataExport: {
                    question: "¿Puedo exportar mis datos?",
                    answer: "Sí, puedes exportar todos tus datos en cualquier momento en formato CSV o PDF. Tus datos son tuyos y nunca estás bloqueado.",
                },
                emailImport: {
                    question: "¿Cómo funciona la importación de correo electrónico?",
                    answer: "Cada coche tiene una dirección de correo electrónico única. Simplemente reenvía tus facturas y extraeremos los datos automáticamente.",
                },
                multipleUsers: {
                    question: "¿Pueden varias personas acceder al mismo coche?",
                    answer: "Actualmente, cada coche pertenece a una cuenta. Sin embargo, puedes hacer que un coche sea visible públicamente para compartir acceso solo de lectura con otros.",
                },
            },
        },
        cta: {
            title: "Deja de adivinar. Empieza a saber.",
            subtitle: "Convierte el historial de tu coche en decisiones financieras claras. Únete a miles de propietarios inteligentes que saben exactamente cuándo invertir o vender.",
            button: "Empezar ahora",
            note: "Sin tarjeta de crédito. Sin ventas agresivas. Solo claridad.",
        },
        footer: {
            product: "Producto",
            legal: "Legal",
            changelog: "Registro de cambios",
            privacy: "Política de privacidad",
            contact: "Contáctenos",
            contactEmail: "info@mycarcosts.com",
            questions: "¿Tiene preguntas? Contáctenos en:",
        },
        privacy: {
            title: "Política de privacidad",
            lastUpdated: "Última actualización: 25 de marzo de 2026",
            introduction: "En My Car Costs, nos tomamos en serio su privacidad. Esta política explica cómo manejamos sus datos de acuerdo con los estándares de privacidad modernos, incluido el GDPR.",
            dataCollection: {
                title: "Recopilación de datos",
                description: "Solo recopilamos el mínimo absoluto de información necesaria para proporcionar nuestro servicio.",
                email: "Identidad de la cuenta: Utilizamos su dirección de correo electrónico como su identificador único y para la autenticación (por ejemplo, enlaces mágicos o inicio de sesión con Google).",
                documents: "Almacenamiento de documentos: Los archivos que carga se almacenan de forma segura en un almacenamiento en la nube cifrado.",
            },
            carData: {
                title: "SU control sobre los datos",
                description: "La información que ingresa (gastos, kilometraje, repuestos) se almacena para su uso personal y para análisis.",
                noValidation: "No validamos los datos del automóvil que proporciona; es su responsabilidad garantizar su exactitud.",
                privateByDefault: "De forma predeterminada, sus datos son privados. Los identificadores técnicos de los archivos no son secuenciales y no están indexados por los motores de búsqueda.",
                rightToForgotten: "Derecho al Olvido: Puede eliminar su cuenta en cualquier momento, eliminando de forma inmediata y permanentemente todos sus registros y archivos.",
            },
            thirdParty: {
                title: "Servicios de terceros",
                description: "No vendemos sus datos personales. Cuando utiliza el inicio de sesión de Google, solo accedemos a su dirección de correo electrónico con fines de identificación.",
            },
            emailIngestion: {
                title: "Procesamiento de Correo Electrónico",
                description: "Los correos electrónicos enviados a nuestro servicio de procesamiento se almacenan para proporcionar un historial. Puedes eliminar manualmente correos electrónicos individuales o todo tu historial en cualquier momento.",
            },
        },
        emails: {
            deleteAll: "Eliminar Todo",
            deleteAllConfirm: "¿Estás seguro de que deseas eliminar todo el historial de correos electrónicos para este coche? Esta acción es irreversible.",
            deleteConfirm: "¿Estás seguro de que deseas eliminar este correo electrónico?",
            noEmails: "No se han recibido correos electrónicos aún.",
        },
        terms: {
            title: "Términos y Condiciones",
            lastUpdated: "Actualizado: 25 de marzo de 2026",
            introduction: "Al acceder o utilizar MyCarCosts, aceptas estar sujeto a estos Términos y Condiciones. Si no estás de acuerdo, por favor no utilices nuestro servicio.",
            acceptance: {
                title: "1. Aceptación de los Términos",
                description: "Estos términos constituyen un acuerdo legalmente vinculante entre tú y MyCarCosts con respecto al uso de nuestra aplicación y servicios.",
            },
            service: {
                title: "2. Descripción del Servicio",
                description: "MyCarCosts proporciona una plataforma para el seguimiento de gastos del vehículo, gestión de mantenimiento y análisis financiero. Esto incluye herramientas de reconocimiento de recibos por IA.",
            },
            responsibilities: {
                title: "3. Responsabilidades del Usuario",
                description: "Eres responsable de la precisión de cualquier dato que ingreses, incluidos kilometraje, números VIN y costos. Debes mantener seguras tus credenciales de acceso.",
            },
            plans: {
                title: "4. Planes de Servicio y Límites",
                description: "Ofrecemos planes Gratuitos y Pro con diferentes límites de almacenamiento, coches y subidas. Nos reservamos el derecho de modificar estos límites en cualquier momento.",
            },
            disclaimer: {
                title: "5. Descargos de Responsabilidad",
                description: "MyCarCosts es una herramienta informativa. No proporcionamos certificaciones oficiales de estado del vehículo. Los datos procesados por IA siempre deben ser verificados por el usuario.",
            },
            liability: {
                title: "6. Limitación de Responsabilidad",
                description: "MyCarCosts se proporciona 'tal cual'. No somos responsables de problemas mecánicos, pérdidas financieras o inexactitudes de datos resultantes del uso de nuestra aplicación.",
            },
            termination: {
                title: "7. Terminación",
                description: "Puedes dejar de usar el servicio y eliminar tus datos en cualquier momento. Nos reservamos el derecho de suspender cuentas que violen estos términos o realicen abusos.",
            },
        },
    },
            audit: {
        hero: {
            badge: 'New: Protection Tool',
            title: 'Consult the Oracle.',
            subtitle: 'Stop second-guessing your mechanic. Paste your quote, describe the noise, or upload a photo. Get a direct, logic-based verdict in 60 seconds.',
            cta: 'Consult the Oracle',
            smallPrint: '100% Private. No credit card required.',
            walletSecurity: 'AI-Powered Security for Your Wallet'
        },
        demo: {
            title: 'Audit Results',
            verdictSell: 'Verdict: SELL',
            repairVsValue: 'Repair vs Value',
            cashGapSavings: 'Cash Gap to Replace',
            savingsValue: '$3,200 Savings',
            roiStrategyTitle: 'ROI Strategy',
            roiStrategyText: 'Investing $2,100 into a deteriorating $4,500 asset is a negative ROI. Replacing with a 2018 model now saves you $3,200 in long-term equity.',
            benefitsTitle: 'Stop Guessing. Master Your Car\'s ROI.',
            ctaSubtext: 'Stop guessing. Put your car\'s costs into logic-driven perspective.'
        },
        form: {
            uploadTitle: 'Photos or Documents (Optional)',
            uploadDesc: 'Upload a photo of your quote or just a picture of the problem area.',
            emailLabel: 'Email Address',
            emailPlaceholder: 'Where to send your report?',
            carLabel: 'Car Model',
            carPlaceholder: 'e.g. 2018 BMW X5 TDI 2.0 sedan',
            descLabel: 'Describe the problem',
            descPlaceholder: 'Paste your mechanic quote, describe the noise, or tell us the problem...',
            submit: 'Consult the Oracle',
            submitting: 'Processing...',
            successTitle: 'Quote Received!',
            successDesc: 'Our AI agents are analyzing your data. You will receive a detailed report at {email} within 60 seconds.',
            errorNoFiles: 'Please provide a description or upload a file.',
            errorNoEmail: 'Please enter your email address.',
            verifiedBy: 'Verified by Double-Agent Protocol'
        },
        progress: {
            analyzing: 'Analysis in progress...',
            scanning: 'Scanning Documents',
            checking: 'Checking Market Data',
            roi: 'ROI Calculations',
            finalizing: 'Finalizing Report',
            lightningTitle: 'First Look Verdict',
            lightningBadge: 'LIGHTNING ANALYSIS',
            firstImpression: 'First Impression',
            checkEmail: 'Check your email in 60 seconds',
            anotherAudit: 'Audit Another Situation',
            statusDesc: 'Our Double-Agent system is scrutinizing your data. The final report will be sent to your email.'
        },
        valueProps: {
            negotiation: {
                title: 'ROI Analysis',
                desc: 'Stop overpaying for labor. Get data-backed arguments for real repair times.'
            },
            peace: {
                title: 'Verdict in 60s',
                desc: 'Know for sure if your mechanic is honest about repairs or trying to "bloat" the bill.'
            },
            scams: {
                title: 'Avoid Common Scams',
                desc: 'Our database found that the average quote in big city dealerships is padded by 22% for "consultation" fees that aren\'t necessary.'
            },
            technical: {
                title: 'Replacement Logic',
                desc: 'We calculate the "Cash Gap" — the true cost of fixing your car versus replacing it with something reliable.'
            }
        },
        cta: {
            title: 'Stop dumping cash into a car that isn’t worth it.',
            button: 'Audit the Situation Now'
        },
        howItWorks: {
            title: 'How It Works',
            subtitle: 'The "Double-Agent" verification system ensures you get facts, not fluff.',
            extract: {
                title: 'Data Intake',
                desc: 'We analyze your situation and car model, factoring in mileage and historical maintenance trends.'
            },
            analyze: {
                title: 'Market Analysis',
                desc: 'Our AI compares repair costs against current market valuations and model reliability scores.'
            },
            audit: {
                title: 'ROI Calculation',
                desc: 'We calculate the financial gap between fixing your current vehicle and moving to a better one.'
            },
            verdict: {
                title: 'The Verdict',
                desc: 'You receive a clear "Repair or Sell" report with logic-driven strategy and priority action items.'
            }
        },
        results: {
            priceRealityCheck: 'Price Reality Check',
            roadmapTitle: 'What breaks next?',
            roadmapBadge: 'Roadmap Teaser',
            unlockFullReport: 'Unlock Full Forensic Audit',
            realWorldInsights: 'Real-World Insights',
            oracleAdvice: 'Real Advice from the Oracle',
            oracleAdviceSub: 'See how our AI helps real people navigate complex car problems every day.',
            readFullAudit: 'Read Full Audit',
            potentialSaving: 'Potential Saving',
            getYourOwn: 'Get your own Oracle Audit',
            savingsPotentialFound: 'Savings Potential Found',
            negotiationScript: 'Negotiation Script'
        },
        caseStudy: {
            backToAudit: 'Back to Audit',
            oracleCaseStudy: 'The Oracle Case Study',
            realUserQuestion: 'The Real User Question',
            officialAudit: 'Official Oracle Audit',
            fullReport: 'Full Resolution Report',
            economicImpact: 'Economic Impact',
            startYourAudit: 'Start Your Own Audit',
            moreAudits: 'More Real-World Audits',
            sharingIsCaring: "Sharing is caring. Save someone else's wallet.",
            poweredBy: 'Powered by MyCarCosts Double-Agent Intelligence'
        }
    },
    jarvis: {
        title: 'Jarvis',
        subtitle: 'AI Garage Agent',
        askJarvis: 'Ask Jarvis...',
        typing: 'Jarvis is thinking...',
        safetyWarning: 'Safety Warning',
        repairVerdict: 'Repair Verdict',
        diyFeasibility: 'DIY Feasibility'
    },
    repairMode: {
        oracleStatus: 'Oracle Status: {status}',
        verdictKeep: 'KEEP',
        verdictSell: 'SELL',
        verdictBorderline: 'BORDERLINE'
    }
};

